import { mediaQueries, palette } from '@centivo/react-components'
import { createGlobalStyle, css } from 'styled-components'

import dashedLine from 'src/assets/Images/backgrounds/dashed-line.svg'

import { Content } from './Structure'

export const TemplateStyles = createGlobalStyle`
  main {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    &:not(.template-eligibility) {
      justify-content: space-between;
    }

    &.banner-open {
      padding-bottom: 2rem;
    }

    > .main-content {
      display: flex;
      flex-direction: column;

      ${({ theme }) => {
        switch (theme.template) {
          case 'template-4':
            return css`
              background-color: #f7f4e6;
              flex-grow: 1;
            `
          case 'template-eligibility':
            return {}

          default:
            return {
              flexGrow: 1,
            }
        }
      }}
    }
    > .template--privacy-policy {
      margin: auto;
      margin-top: 2rem;
      width: 64rem;
      max-width: 98%;
    }
  }

  html:not(.header-hidden) {
    main {
      min-height: calc(100vh - 88px);

      @media ${mediaQueries.desktop} {
        min-height: calc(100vh - 100px);
      }

      @media ${mediaQueries.mobile} {
        min-height: calc(100vh - 74px);
      }
    }
  }

  .home-content {
    &:not(:last-of-type) {
      padding-bottom: 4.75rem;
    }
  }

  .template-eligibility {
    background-color: #F7F4E6;

    > footer {
      font-size: 14px;
    }
  }

  .template-eligibility--header {
    background-color: #F7F4E6;
  }

  main.template-2 > .main-content > ${Content}.home-content section:last-child,
  .result-list section:last-child {
    padding-bottom: 6.25rem;
  }

  main.template-2 > .main-content > .hero-content {
    > section {
      .left {
        max-width: 30rem;
      }
    }
  }

  main:not(.template-2) > .main-content > .hero-content {
    > section .right {
      width: 27.5rem;
      max-width: 100%;
      margin: auto;
    }
  }

  .network-selection section#find-a-doctor {
    @media ${mediaQueries.desktop} {
      min-height: 25.5rem;
    }
  }

  .template-2 > .main-content > .hero-content {
    color: ${palette.neutral.white};
    background: ${
      palette.neutral.white
    } url(${dashedLine}) no-repeat -100px calc(100% - 2.5rem);
    background-size: auto 120px;
    padding-top: 7rem;
    padding-bottom: 12rem;

    > section {
      margin-bottom: 0;

      .right {
        width: 38.5rem;
        max-width: 100%;
      }
    }

    @media (min-width: 1823px) {
      background-size: calc(100% + 100px) auto;
    }

    @media ${mediaQueries.mobile} {
      background-position-y: calc(100% - 1rem);
      background-size: auto 3.25rem;
      background-position-x: -9.25rem;
      padding-top: 1.5rem;
      padding-bottom: 5rem;

      > section .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 0;

        > h2 {
          text-align: center;
          padding: 0;
          margin-bottom: 2rem;
        }
      }
    }
  }

  @media ${mediaQueries.desktop} {
    .template-3 .left {
      margin-right: 8rem;
    }
  }

  @media ${mediaQueries.desktop} and (min-height: 900px) {
    .template-underConstruction {
      height: calc(100% - 6.25rem);
    }
  }

  @media ${mediaQueries.mobile} {
    .template-3 {
      .hero-content section {
        margin-bottom: 3rem;

        > .left {
          margin-bottom: 0;

          h2 {
            padding-top: 0;
            margin-top: 1.5rem;
            text-align: center;
          }
        }
      }

      .submit-search {
        margin-bottom: 0.75rem;
      }
    }
  }
`
